import React, { useEffect, useState } from "react";
import styled from "styled-components";
import CheckboxField from "../reuse/CheckboxField";
import { Button, DisplaySection, NavigationButtons } from "../Styles";
import { useDataContext } from "../../context/DataContext";
import Collapsible from "../reuse/Collapsible";
import ToolTip from "../reuse/ToolTip";

const Buttons = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

const StyledDisplaySection = styled(DisplaySection)`
  margin-bottom: 20px;
`;

function Confirmation({
  requestRecord,
  disableSubmit,
  handleSubmitDocumentation,
  handleSaveLater,
}) {
  const { data } = useDataContext();

  // Find the item in data corresponding to the current id
  const currentItem = data.find((item) => item.id_F === requestRecord.id_F);

  // Initialize isSigned state with the value from data
  const [isSigned, setIsSigned] = useState(
    currentItem ? currentItem.signature_F : false,
  );

  const [isReviewed, setIsReviewed] = useState(
    currentItem ? currentItem.reviewByRequestor_F : false,
  );

  // Update isSigned state when data changes (in case data is dynamic)
  useEffect(() => {
    if (currentItem) {
      setIsSigned(currentItem.signature_F);
      setIsReviewed(currentItem.reviewByRequestor_F);
    }
  }, [currentItem]);

  const handleInputChange = () => {
    setIsSigned(!isSigned);
  };

  /*
  const handleSubmit = (e) => {
    e.preventDefault();

    // Update data context based on id and isSigned
    const updatedData = data.map((item) => {
      if (item.id_F === parseInt(requestRecord.id_F, 10)) {
        return {
          ...item,
          signature_F: isSigned,
        };
      }
      return item;
    });

    // save to backend and then setData
    setData(updatedData);
    // navigate("/requests");

    // Navigate back to the previous route
    // navigate(-1);
  };
  */

  return (
    <Collapsible
      title="Authorization for Release of Information | Autorización para Divulgación
        de Información"
    >
      <div
        dangerouslySetInnerHTML={{
          __html: requestRecord?.authorizationforROI_F,
        }}
      />

      <StyledDisplaySection>
        <CheckboxField
          label="By checking this box, I agree to the above statement"
          helpText="Al marcar esta casilla, acepto la declaración anterior"
          checked={isSigned}
          onChange={handleInputChange}
        />
        <NavigationButtons>
          <Buttons>
            <Button
              style={{ width: "280px" }}
              onClick={handleSaveLater}
              data-tooltip-id="save-and-continue"
            >
              Save & Continue Later
            </Button>
            <ToolTip
              text="Guardar y Continuar más Tarde"
              id="save-and-continue"
            />

            <Button
              style={{ width: "200px" }}
              // disabled={!isSigned}
              disabled={disableSubmit || !isSigned || !isReviewed}
              onClick={handleSubmitDocumentation}
              data-tooltip-id="submit"
            >
              Submit
            </Button>
            <ToolTip text="Ingresar" id="submit" />
          </Buttons>
        </NavigationButtons>
      </StyledDisplaySection>
    </Collapsible>
  );
}

export default React.memo(Confirmation);
